
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import ImageBanner from '../ImageBanner/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ClickEvent } from '@xt/client/types/home'

enum EnumDetailPage {
  Beginner = 'beginner',
  Junior = 'junior',
  Advanced = 'advanced',
  Senior = 'senior'
}

@Observer
@Component({
  components: {
    LazyImg,
    ImageBanner
  }
})
export default class LearnMap extends Mixins(MixinsHomeClick) {
  toCourseDetail(item: { cover: string; event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
    }
  }
  // 跳转详情页
  toDetail(page: EnumDetailPage) {
    if (!this.PageStore.dataSource) return

    const target = this.PageStore.dataSource[page]

    if (!target) return

    if (target.event) {
      this.onClickEvent(target.event)
    }
  }

  get EnumDetailPage() {
    return EnumDetailPage
  }

  get PageStore() {
    return this.$store.$storeActivitys.Calligraphy
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
